import * as _actions from './actions.js';

const actions = _actions;
export default actions;



// WEBPACK FOOTER //
// ./data/ProgressReports/RejectByDos/index.js